<nav
  [attr.aria-label]="'checkoutProgress.label' | cxTranslate"
  *ngIf="(activeStepIndex$ | async) !== undefined"
>
  <div class="cx-nav d-none d-lg-block d-xl-block">
    <ul class="cx-list">
      <ng-container *ngFor="let step of steps$ | async; let i = index">
        <li
          class="cx-item"
          [class.active]="isActive(i)"
          [class.disabled]="isDisabled(i)"
        >
          <a
            [routerLink]="
              {
                cxRoute: step.routeName,
                params: [params$ | async],
              } | cxUrl
            "
            class="cx-link"
            [attr.aria-current]="isActive(i) ? 'step' : null"
            [attr.aria-disabled]="isDisabled(i) ? 'true' : null"
            [class.active]="isActive(i)"
            [class.disabled]="isDisabled(i)"
            [tabindex]="getTabIndex(i)"
            [innerHTML]="
              step.nameMultiLine !== false
                ? (step.name | cxTranslate | cxMultiLine)
                : (step.name | cxTranslate)
            "
            [attr.aria-label]="
              'checkoutProgress.state.' + getStepState(i)
                | cxTranslate
                  : {
                      step: step.name | cxTranslate,
                    }
            "
          >
          </a>
        </li>
      </ng-container>
    </ul>
  </div>
</nav>
